import { ObjectSchema, boolean, mixed, number, object, string } from "yup";
import { LicenseCreationsFilter } from "../../../../../../../generated/data-contracts";
import { FilterType, ResCallback } from "../../../../../../../models";

export const validationCreationPicker = (
  res: ResCallback,
): ObjectSchema<LicenseCreationsFilter> => {
  const validationSchema: ObjectSchema<LicenseCreationsFilter> = object({
    creationClassId: number(),
    creationName: string(),
    creationNameFilterType: mixed<FilterType>(),
    creationStatusId: number(),
    rightsHolderName: string(),
    creationBand: string(),
    pageIndex: number().min(0),
    pageSize: number()
      .min(1)
      .when(["creationName", "rightsHolderName", "creationBand"], {
        is: (
          creationNameVal: string | undefined,
          rightsHolderNameVal: string | undefined,
          creationBandVal: string | undefined,
        ) => !creationNameVal && !rightsHolderNameVal && !creationBandVal,
        then: (schema) =>
          schema.max(
            0,
            res(
              "validation_LicenseReport_PP_1Of3_FilterValuesNeeded",
              res("label_Title"),
              res("label_Author"),
              res("label_Performer"),
            ),
          ),
      }),
    searchAllNames: boolean(),
  });

  return validationSchema;
};
